import * as React from 'react'
import { ReactElement } from 'react'
import { Switch, SwitchProps } from '@fluentui/react-components'
import { FileModuleDto } from '../../hooks/module/useFileModule'
import { useFormikContext } from 'formik'
import { FileMutationDto } from '../../config/fileConfig'
import { ModuleType } from '../../context/GlobalContext'
import { useTranslation } from 'react-i18next'

export type FileModuleSwitchProps<ModuleT extends FileModuleDto> = SwitchProps & {
    moduleType: ModuleType
    defaultValues: ModuleT
    onAfterChecked?: () => void
    onAfterUnchecked?: () => void
}

export default function FileModuleSwitch<ModuleT extends FileModuleDto = FileModuleDto>(
    props: FileModuleSwitchProps<ModuleT>,
): ReactElement {
    const { t: translate } = useTranslation()
    const { initialValues, values, setFieldValue } = useFormikContext<FileMutationDto>()

    return (
        <Switch
            checked={props.checked}
            label={props.checked ? translate('base.toggle.boolean.true') : translate('base.toggle.boolean.false')}
            onChange={event => {
                if (event.currentTarget.checked) {
                    const modules: FileModuleDto[] = values.modules ?? []
                    modules?.push(
                        props.checked
                            ? initialValues.modules?.find(value => value.type === props.moduleType)
                            : props.defaultValues,
                    )
                    setFieldValue('modules', modules)
                    props.onAfterChecked?.()
                } else {
                    setFieldValue(
                        'modules',
                        values.modules?.filter(value => value.type !== props.moduleType),
                    )
                    props.onAfterUnchecked?.()
                }
            }}
        />
    )
}
